import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    LoaderComponent,
  ],
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    TranslateModule,
  ],
  exports: [
    LoaderComponent,
  ]
})
export class LoaderModule { }
